<template>
  <article class="project_header">
    <ParticalsComponent />
    <div class="img_container wow fadeInDown">
      <img
        :src="getImgUrl(headerImage)"
        :alt="title"
        loading="lazy"
        draggable="false"
      />
    </div>
    <h3 class="wow fadeInUp">{{ title }}</h3>
  </article>
</template>

<script>
import ParticalsComponent from "@/components/ParticalsComponent";
import { getImgUrl } from "@/util/methods";
export default {
  name: "ProjectPageHeader",
  components: {
    ParticalsComponent,
  },
  methods: {
    getImgUrl,
  },
  props: ["title", "headerImage"],
};
</script>
